import React from 'react';
import { Search } from '../../../../../Desktop/Header/Search/Search';

export class SearchForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      noSearchResultsFound: true,
    };
  }

  render() {
    var widgetData = this.props.widgetData;
    return (
      <div className='SearchForm col-12 col-md-6 col-lg-4'>
        <div className='row'>
          <h3 className='col-12 p-0'>Try a different search term:</h3>
          <Search passedAppFunctions={this.props.passedAppFunctions} noSearchResults={this.state.noSearchResults} />
        </div>
      </div>
    );
  }
}

export default SearchForm;
